"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyDrawingWithLayersSchema = void 0;
exports.DrawingWithLayersSchemaT = DrawingWithLayersSchemaT;
const zod_1 = require("zod");
const AnyDrawingSchema_1 = require("./AnyDrawingSchema");
function DrawingWithLayersSchemaT(drawingSchema) {
    return zod_1.z.object({
        layers: zod_1.z.number().array(),
        drawing: drawingSchema,
    });
}
exports.AnyDrawingWithLayersSchema = zod_1.z.object({
    layers: zod_1.z.number().array(),
    drawing: AnyDrawingSchema_1.AnyDrawingSchema,
});
//# sourceMappingURL=DrawingWithLayers.js.map